var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MultiColumnList } from '@folio/stripes/components';
import React, { useMemo, useState } from 'react';
import { dateCompare } from '../utils/DateUtils';
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASCENDING"] = "ascending";
    SortDirection["DESCENDING"] = "descending";
})(SortDirection || (SortDirection = {}));
export function flipSortDirection(direction) {
    return direction === SortDirection.ASCENDING
        ? SortDirection.DESCENDING
        : SortDirection.ASCENDING;
}
export function getInitialSort(sortedColumn, sortDirection) {
    if (sortedColumn === undefined)
        return [];
    return [
        {
            key: sortedColumn,
            direction: sortDirection === 'descending'
                ? SortDirection.DESCENDING
                : SortDirection.ASCENDING
        }
    ];
}
export function sortBy(data, key, direction, dateColumns, dateColumnMap) {
    if (dateColumns === void 0) { dateColumns = []; }
    if (dateColumnMap === void 0) { dateColumnMap = {}; }
    data.sort(function (a, b) {
        if ((a === null || a === void 0 ? void 0 : a[key]) === undefined || a[key] === null) {
            return direction === SortDirection.ASCENDING ? -1 : 1;
        }
        if ((b === null || b === void 0 ? void 0 : b[key]) === undefined || b[key] === null) {
            return direction === SortDirection.ASCENDING ? 1 : -1;
        }
        if (dateColumns === null || dateColumns === void 0 ? void 0 : dateColumns.includes(key)) {
            return ((direction === SortDirection.ASCENDING ? 1 : -1) *
                dateCompare(a[dateColumnMap[key]], b[dateColumnMap[key]]));
        }
        return ((direction === SortDirection.ASCENDING ? 1 : -1) *
            a[key]
                .toString()
                .localeCompare(b[key].toString()));
    });
}
export default function SortableMultiColumnList(props) {
    var sortedColumn = props.sortedColumn, sortDirection = props.sortDirection, contentData = props.contentData, dateColumns = props.dateColumns, dateColumnMap = props.dateColumnMap, rest = __rest(props, ["sortedColumn", "sortDirection", "contentData", "dateColumns", "dateColumnMap"]);
    // first element is the primary sort, optional secondary
    var _a = useState(getInitialSort(sortedColumn, sortDirection)), sort = _a[0], setSort = _a[1];
    var data = useMemo(function () {
        var newData = __spreadArray([], contentData, true);
        sort
            .slice()
            .reverse()
            .forEach(function (sorting) {
            return sortBy(newData, sorting.key, sorting.direction, dateColumns, dateColumnMap);
        });
        return newData;
    }, [contentData, sort, dateColumns, dateColumnMap]);
    var sortProps = useMemo(function () {
        if (sort.length === 0)
            return {};
        return {
            sortedColumn: sort[0].key,
            sortDirection: sort[0].direction
        };
    }, [sort]);
    return (React.createElement(MultiColumnList, __assign({}, rest, sortProps, { onHeaderClick: function (_e, _a) {
            var name = _a.name;
            if (sort.length >= 1 && sort[0].key === name) {
                // toggling the primary sort
                var newSort = __spreadArray([], sort, true);
                newSort[0].direction = flipSortDirection(sort[0].direction);
                setSort(newSort);
            }
            else if (sort.length <= 1) {
                // new sort, no secondary
                setSort(__spreadArray([{ key: name, direction: SortDirection.ASCENDING }], sort, true));
            }
            else {
                // old primary is the new secondary
                // if sort[1] was the clicked header, it is replaced, so no worry about the
                // two sorts being the same key
                setSort([{ key: name, direction: SortDirection.ASCENDING }, sort[0]]);
            }
        }, contentData: data })));
}
